export const SUPPORTED_PLAN_KEYS = new Set([
  "basic_monthly",
  "pro_monthly",
  "basic_yearly",
  "pro_yearly",
]);

const PLAN_KEY_FIELDS = [
  "plan",
  "subscription_plan",
  "plan_name",
  "plan_key",
  "price_plan",
  "price_name",
  "product_name",
  "subscription_name",
];

const PLAN_TYPE_FIELDS = [
  "plan_type",
  "planType",
  ...PLAN_KEY_FIELDS,
];

const INTERVAL_FIELDS = [
  "interval",
  "billing_interval",
  "billingInterval",
  "cycle",
  "period",
  "plan_interval",
  "planInterval",
  "price_interval",
  "priceInterval",
  "recurring_interval",
  "recurringInterval",
  ...PLAN_KEY_FIELDS,
];

const normalizeValue = (value = "") =>
  String(value).trim().toLowerCase().replace(/[\s-]+/g, "_");

const getValues = (sources, fields) =>
  sources.flatMap((source) =>
    fields
      .map((field) => source?.[field])
      .filter(Boolean)
  );

export const normalizeInterval = (value = "") => {
  const normalized = normalizeValue(value);
  if (normalized === "month") return "monthly";
  if (normalized === "year") return "yearly";
  return normalized;
};

export const normalizePlanType = (value = "") => {
  const normalized = normalizeValue(value);
  if (normalized === "basic" || normalized === "pro") return normalized;
  return "";
};

export const normalizePlanKey = (value = "") => {
  const normalized = normalizeValue(value);
  if (!normalized) return "";
  if (SUPPORTED_PLAN_KEYS.has(normalized)) return normalized;

  const parts = normalized.split("_").filter(Boolean);
  const planType = parts.map(normalizePlanType).find(Boolean);
  const interval = parts
    .map(normalizeInterval)
    .find((part) => part === "monthly" || part === "yearly");

  if (!planType || !interval) return "";

  const normalizedPlanKey = `${planType}_${interval}`;
  return SUPPORTED_PLAN_KEYS.has(normalizedPlanKey) ? normalizedPlanKey : "";
};

export const getSubscriptionPlanType = (...sources) => {
  const values = getValues(sources, PLAN_TYPE_FIELDS)
    .join(" ")
    .toLowerCase();

  if (values.includes("pro")) return "pro";
  if (values.includes("basic")) return "basic";
  return "";
};

export const getSubscriptionIntervalKey = (...sources) => {
  const values = getValues(sources, INTERVAL_FIELDS)
    .join(" ")
    .toLowerCase();

  if (values.includes("year")) return "yearly";
  if (values.includes("month")) return "monthly";
  return "";
};

export const getSubscriptionPlanKey = (...sources) => {
  for (const candidate of getValues(sources, PLAN_KEY_FIELDS)) {
    const normalized = normalizePlanKey(candidate);
    if (normalized) return normalized;
  }

  const planType = getSubscriptionPlanType(...sources);
  const interval = getSubscriptionIntervalKey(...sources);
  const composedPlanKey = `${planType}_${interval}`;

  return SUPPORTED_PLAN_KEYS.has(composedPlanKey) ? composedPlanKey : "";
};
